import Image from 'next/image';

import cn from 'classnames';

import { ModalContent, ModalContentBody } from '@/components/elements/ModalContent';
import Flyout from '@/components/Flyout';

import './PromotionBonusModal.scss';

const PromotionBonusModal = ({
  captionText = '',
  children,
  description,
  hidePromoImage,
  imgSrc,
  isConfirmationNew,
  isOpen,
  onCloseModal,
  title,
}) => {
  const promoImageClasses = cn('PromotionBonusModal__img', {
    hidePromoImage,
  });

  return (
    <Flyout
      className={`${!isConfirmationNew ? 'PromotionBonusModal' : 'PromotionBonusModal confirmationNewModal'}`}
      direction="modal"
      onDismiss={onCloseModal}
      open={isOpen}
    >
      <ModalContent className="share-with-friend">
        <ModalContentBody className="Promotion__info">
          <h1 className="PromotionBonusModal__title">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </h1>
          <p className="PromotionBonusModal__description">
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </p>
          {children}
        </ModalContentBody>
      </ModalContent>
      <div className={promoImageClasses}>
        <div className="imageContainer">
          <Image
            alt={captionText}
            className="image"
            fill
            loading="eager"
            quality="75"
            sizes="100vw, 100vh"
            src={imgSrc}
          />
        </div>
      </div>
    </Flyout>
  );
};

export default PromotionBonusModal;
